<template>
  <perfect-scrollbar id="home" class="content">
    <SkAnimation v-if="loading" :tab="false" :thumb="false"/>
    <div class="mediaCnt" v-else>
      <div class="lthHeaderCnt">
        <div class="lBtn refresh" v-on:click="getData"></div>
        <div class="pagination">
          <div class="pageInfo">{{((page * limit) + 1).toLocaleString('id')}}-{{((page
            * limit) + allMedia.length).toLocaleString('id')}} dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + allMedia.length) >= total}"
            v-on:click="nextPage"></div>
        </div>
      </div>

      <div class="mediaItem" v-for="(media, index) in allMedia" :key="index"
        v-on:click="mediaDetail(media)">
        <div class="mediaThumb" :style="{'background-image': `url(${media.imageMd})`}"/>
        <div class="delete" v-on:click.stop="deleteMedia(media)"/>
        <div class="video" v-if="media.file_type === 'video/youtube'"/>
        <div class="image" v-if="media.file_type.split('/')[0] === 'image'"/>
        <div class="processing" v-if="media.status === 'processing'">
          <span>Processing</span>
        </div>
        <div class="audio" v-if="media.type === 'audio'">
          <div>
            <div class="audioIcon"/>
            <h4>{{media.name | substr(50, '...')}}</h4>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <MediaDetail ref="mediaDetail"/>
  </perfect-scrollbar>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import MediaDetail from '@/components/MediaDetail.vue';
import SkAnimation from '@/components/SkAnimation.vue';

export default {
  name: 'media',
  components: {
    SkAnimation, Confirmation, MediaDetail,
  },
  data() {
    return {
      loading: true,
      allMedia: [],
      deleteConfirmation: false,
      deleteTitle: '',
      deleteDesc: '',
      mediaWillDelete: null,
      limit: 30,
      page: 0,
      total: 0,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    save() {
      this.draftStatus = 'loading';
      this.$http.post(this.$config.uri('page/config/homepage'), this.model).then((r) => {
        this.draftStatus = 'saved';
        setTimeout(() => {
          this.draftStatus = null;
        }, 1200);
      });
    },
    fieldChanged(e, field) {
      this.model[field] = e.target.innerHTML;
    },
    deleteMedia(item) {
      this.$refs.confirmDialog.open({
        title: 'Delete Media',
        desc: 'Are you sure you want to delete this media?',
      }, (b) => {
        if (!b) return;
        this.$http.get(this.$config.uri(`media/${item.id}/delete`)).then((r) => {
          this.getData();
        });
      });
    },
    mediaDetail(item) {
      this.$refs.mediaDetail.open(item);
    },
    nextPage() {
      if (((this.page * this.limit) + this.allMedia.length) >= this.total) return;
      this.page += 1;
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      this.getData();
    },
    getData() {
      this.$http.get(this.$config.uri(`media/all?page=${this.page}`)).then((r) => {
        this.loading = false;
        this.allMedia = (r.data.status === 200) ? r.data.data : null;
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
  },
  mounted() {
    this.chTitle('All Media');
    this.chCGB(false);
    this.getData();
  },
};
</script>

<style scoped lang="scss">
  .mediaCnt{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    padding: 0 0 20px;
    .lthHeaderCnt{
      width: 100%;
      margin: 0 -20px 20px;
      padding-left: 20px; padding-right: 20px;
    }
    .mediaItem{
      width: calc(20% - 20px);
      height: 10vw;
      margin: 0 10px 20px;
      border-radius: 5px;
      position: relative;
      overflow: hidden;
      transition: all .3s ease;
      .mediaThumb{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-size: contain;
        background-color: #eee;
        background-position: center;
        background-repeat: no-repeat;
      }
      &:hover{
        cursor: pointer;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      }
      .delete, .edit{
        width: 30px;
        height: 30px;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        z-index: 2;
        right: 10px; top: 10px;
        background-image: url(../assets/delete.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        &:hover{
          cursor: pointer;
          background-color: #ccc;
        }
      }
      .video, .image{
        width: 30px;
        height: 30px;
        background-color: #e21717;
        border-radius: 3px;
        position: absolute;
        z-index: 2;
        bottom: 10px; left: 10px;
        background-image: url(../assets/video.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      .image{
        background-color: #0072ff;
        background-image: url(../assets/photo.png);
      }
      .audio, .processing{
        background-color: #d9d6e4;
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 0 20px;
        .audioIcon{
          width: 30px;
          height: 30px;
          background-image: url(../assets/musical-note.svg);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          margin: 0 auto 12px;
        }
        h4{
          margin: 0;
          font-size: 16px;
          line-height: 1.3;
        }
      }
      .processing{
        z-index: 1;
        background: orange !important;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        span{
          position: relative;
          z-index: 3;
          color: #444;
          font-size: 12px;
          font-size: 24px;
        }
        @-webkit-keyframes MOVE-BG {
          from {
            -webkit-transform: translateX(0);
          }
          to {
            -webkit-transform: translateX(46px);
          }
        }
        @keyframes MOVE-BG {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(46px);
          }
        }
        &:before{
          display: block;
          content: "";
          position: absolute;
          left: -46px;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
          background: -webkit-repeating-linear-gradient(
            145deg,
            rgba(0,0,0,.1) 1px,
            rgba(0,0,0,0) 2px,
            rgba(0,0,0,0) 11px,
            rgba(0,0,0,.1) 12px,
            rgba(0,0,0,.1) 20px
          );
          background: repeating-linear-gradient(
            -55deg,
            rgba(0,0,0,.1) 1px,
            rgba(0,0,0,0) 2px,
            rgba(0,0,0,0) 11px,
            rgba(0,0,0,.1) 12px,
            rgba(0,0,0,.1) 20px
          );
          -webkit-animation-name: MOVE-BG;
          -webkit-animation-duration: .6s;
          -webkit-animation-timing-function: linear;
          -webkit-animation-iteration-count: infinite;
          animation-name: MOVE-BG;
          animation-duration: .6s;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
      }
      .edit{
        right: 45px;
        background-image: url(../assets/edit.png);
      }
    }
  }
</style>
